import api from "./api";
import { URLs, urlsControle } from "./urls";
import { encrypt } from './crypto';

export const TOKEN_KEY = "@Capittale-Token";
export const TOKEN_USER = "@Capittale-User";
export const TOKEN_PERMISSIONS = "@Capittale-User-Permissions";
export const TOKEN_PAGINATION = "@Capittale-User-Pagination";
export const TOKEN_WEB_SETTING = "@Capittale-Web-Setting";
export const TOKEN_MENU = "@Capitalle-Menu"
export const TOKEN_MENU_SUPERIORS = "@Capitalle-Menu-Superiors"
export const TOKEN_CURRENT_MENU = "@Capitalle-Current-Menu"

export const isAuthenticated = () => sessionStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const getUser = () => JSON.parse(sessionStorage.getItem(TOKEN_USER));

export const findPermission = (moduloId, permissao = null) => {
  if (getPermissions({ moduloId, permissao })) {
    return true;
  }
  return false;
};

export const findSomePermission = (moduloId, permissao) => {
  const { permissions } = JSON.parse(sessionStorage.getItem(TOKEN_PERMISSIONS));
  if (permissao) {
    return !!permissions.find(
      (x) => x.moduloId === moduloId && x.permissao === permissao
    );
  } else {
    return !!permissions.find((x) => x.moduloId === moduloId);
  }
};

export const findDynamicReports =() => {
  const menus = JSON.parse(sessionStorage.getItem(TOKEN_PERMISSIONS));
  const reports = menus ? menus.permissions.filter((x) => x.tipo === 'RelatorioDinamico'
  && x.permissao === 'Consultar' && x.mostrarBotao)
  : [];
  console.log(reports)
  return reports
}

export const findTitulo = (moduloId) => {
  const { permissions } = JSON.parse(sessionStorage.getItem(TOKEN_PERMISSIONS));
  return permissions.find((x) => x.moduloId === moduloId)?.titulo;
};

export const findModule = (moduloId) => {
  const { permissions } = JSON.parse(sessionStorage.getItem(TOKEN_PERMISSIONS));
  return permissions.find((x) => x.moduloId === moduloId);
};

export const getDynamicId = (modulo) => {
  const stringLength = modulo.length
  return '/' + modulo.substring(stringLength - 4)
}

export const getURL = (moduloId) => {
  const module = findModule(moduloId)
  if(!module) return '#'
  const moduleName = module.tipo == "RelatorioDinamico" ? "RelatoriosDinamicos" : module.modulo
  const { permissions } = JSON.parse(sessionStorage.getItem(TOKEN_PERMISSIONS));
  if(URLs[moduleName]) {
    const res = permissions.filter(
      (p) => p.modulo === URLs[moduleName].permissao
    );
    if (
      res.find((p) => p.permissao === "Consultar" || p.permissao === "Alterar")
    ) {
      return URLs[moduleName].urlVisualizacao + (module.tipo == "RelatorioDinamico" ? getDynamicId(module.modulo) : '');
    }
    if (res.find((p) => p.permissao === "Cadastrar")) {
      return URLs[moduleName].urlCriacao + (module.tipo == "RelatorioDinamico" ? getDynamicId(module.modulo) : '');
    }
    return URLs[moduleName].urlVisualizacao + (module.tipo == "RelatorioDinamico" ? getDynamicId(module.modulo) : '');
  } 
  return '#'
};

export const getUrlControle = (controle) => {
  return urlsControle[controle - 1]
}

export const calcLengthBtnMenu = (text, setLargerItemLenght,largerItemLenght) => {
  var margin = 20;
  var letterLength = 8;
  var total = margin + letterLength * text.length;

  if (total > largerItemLenght) {
    setLargerItemLenght(total);
    return total;
  }
  return largerItemLenght;
};

export const getPermissions = ({ moduloId, permissao }) => {
  const permissoes = JSON.parse(sessionStorage.getItem(TOKEN_PERMISSIONS));
  const findModule = permissoes
    ? permissoes.permissions.filter((x) => x.moduloId === moduloId)
    : [];
  if (findModule.length) {
    if (permissao) {
      const findPermission = findModule.find((x) => x.permissao === permissao);
      return findPermission;
    }
    return findModule;
  } else {
    return false;
  }
};

export const login = ({
  configuracoesAmbienteWeb,
  login,
  loginId,
  nome,
  paginacao,
  permissions,
  token,
  obrigaRegistrarPonto,
  proximoDiaUtil,
  menuSuperiors,
  menus,
}) => {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(
    TOKEN_USER,
    JSON.stringify({ nome, loginId, login, obrigaRegistrarPonto, proximoDiaUtil })
  );
  sessionStorage.setItem(TOKEN_PERMISSIONS, JSON.stringify({ permissions }));
  sessionStorage.setItem(TOKEN_MENU, JSON.stringify({ menus }));
  sessionStorage.setItem(TOKEN_MENU_SUPERIORS, JSON.stringify({ menuSuperiors }));
  sessionStorage.setItem(TOKEN_PAGINATION, JSON.stringify({ paginacao }));
  sessionStorage.setItem(
    TOKEN_WEB_SETTING,
    JSON.stringify({ configuracoesAmbienteWeb })
  );
};

export const logout = async () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_USER);
  sessionStorage.removeItem(TOKEN_PERMISSIONS);
  sessionStorage.removeItem(TOKEN_WEB_SETTING);
  sessionStorage.removeItem(TOKEN_PAGINATION);
  sessionStorage.removeItem(TOKEN_MENU);
  sessionStorage.removeItem(TOKEN_MENU_SUPERIORS);
  sessionStorage.removeItem(TOKEN_CURRENT_MENU)
  try {
    await api.post("Autenticacao/Logout");
    return true;
  } catch (error) {
    console.log(error.response);
    return false;
  }
};

export const timeRegitered = () => {
  if (sessionStorage.getItem(TOKEN_USER)) {
    try {
      const user = JSON.parse(sessionStorage.getItem(TOKEN_USER));

      if (user.obrigaRegistrarPonto) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      return false;
    }
  }

  return false;
};

export const updateTimeRegistered = (obrigaRegistrarPonto) => {
  const user = JSON.parse(sessionStorage.getItem(TOKEN_USER));
  user.obrigaRegistrarPonto = obrigaRegistrarPonto;
  sessionStorage.setItem(TOKEN_USER, JSON.stringify(user));
};


export const signEthicsCode = async (password) => {
  try {
    const user = getUser(); // Obtém o usuário do sessionStorage
    
    if (!user || !user.loginId) {
      throw new Error('Usuário não autenticado ou loginId não disponível');
    }

    const response = await api.post('/ColaboradoresCodigosDeEticas/assinar', {
      loginId: user.loginId, // Passa o loginId
      senha: encrypt(password) // Senha criptografada
    });
    
    if (response.data.sucesso) {
      return response.data;
    } else {
      throw new Error(response.data.mensagem || 'Erro ao assinar o código de ética');
    }
  } catch (error) {
    if (error.response) {
      // Erro retornado pelo backend
      throw new Error(error.response.data.message || 'Erro ao assinar o código de ética');
    }
    throw error;
  }
};

export const checkEthicsCodeSignature = async () => {
  try {
    const user = getUser(); // Esta função já está definida e pega o usuário do sessionStorage
    if (!user || !user.loginId) {
      throw new Error('Usuário não autenticado ou loginId não disponível');
    }
    
    const response = await api.get(`/ColaboradoresCodigosDeEticas/verificar-assinatura/${user.loginId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar assinatura:', error);
    throw error;
  }
};